
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TextArea',
  props: {
    label: {
      type: String,
      required: true
    },
    labelClass: {
      type: String,
      required: false,
      default: 'text-gray-900'
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    },
    height: {
      type: String,
      required: false,
      default: 'h-40'
    },
    isIncorrect: {
      type: Boolean,
      required: false,
      default: false
    },
    incorrectMessage: {
      type: String,
      required: false,
      default: 'Campo incorreto!'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    optional: {
      type: Boolean,
      required: false,
      default: false
    },
    hideIncorrectMessage: {
      type: Boolean,
      required: false,
      default: false
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'off'
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    modelValue: {
      type: String,
      required: false
    }
  },
  emits: ['update:modelValue']
})
